import Box from "@mui/material/Box";
import { useTheme } from "@mui/material";
import { Message } from "../../stores/ChatClientStore";

type Props = {
    message: Message,
    userId: string
}

const ChatMessage = ({ message, userId }: Props) => {
    const theme = useTheme();

    return (
        <Box padding={2} border={`1px solid ${theme.palette.divider}`} margin={2} borderRadius={2} width='fit-content' alignSelf={message.userId === userId ? 'end' : undefined}>
            {message.fileName && <img src={`/api/conversations/images/${message.fileName}` }/> }
            {message.text}            
        </Box>
    )
}
 
export default ChatMessage;